/*
*
* File JS componente Block Offers
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import Swiper from 'swiper/bundle';

//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-offers.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockOffers = () => {
    let swiperOffers = document.querySelector('.block-offers .swiper-container'); 

    if (!swiperOffers) return;

    let arrowPrev = document.querySelector('.block-offers .swiper-button-prev');
    let arrowNext = document.querySelector('.block-offers .swiper-button-next');

    let slidesPerViewDesk = 1;

    if (swiperOffers.querySelectorAll('.swiper-slide').length > 1)
    {
        slidesPerViewDesk = 2;
    }

    let args = {
        breakpoints: {
            0: {
                slidesPerView: 1.1,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: slidesPerViewDesk,
                spaceBetween: 25,
            },
        },
        navigation: 
        {
            nextEl: arrowNext,
            prevEl: arrowPrev,
        },
        a11y: {
            enabled: true,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            notificationClass: 'swiper-notification'
        },
    };

    new Swiper(swiperOffers, args);
}

export default blockOffers;

//--------------------------------------------------------------------//